<template>
  <div class="table">
    <div class="row">
      <table class="memberOptionsTable">
        <thead>
          <th></th>
          <th class="silverTabHead"><h3>Silver</h3><p>Save up to 25% off RRP</p></th>
          <th class="goldTabHead"><h3>Gold</h3><p>Save up to 60% of RRP </p></th>
          <th class="platinumTabHead"><h3>Platinum</h3><p>Save up to 65% off RRP</p></th>
          <!-- <th><h3>Catalogue</h3></th> -->
        </thead>
        <tbody ref="tableBody">
          <tr v-for="(row, index) in this.tableData" :key="index">
            <td class="col-1" v-html="row['&nbsp;']"></td>
            <td class="col-2"><img class="redTick" src="@/assets/img/redTick.png" v-if="row['Silver']"/></td>
            <td class="col-3"><img class="redTick" src="@/assets/img/redTick.png" v-if="row['Gold']"/></td>
            <td class="col-4"><img class="redTick" src="@/assets/img/redTick.png" v-if="row['Platinum']"/></td>

            <!-- <td class="col-3" v-html="row['Catalogue']"></td>-->
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

export default {
	name: 'MembershipOptions',
	components: {},
	props:["content"],
	mounted(){
	},
	methods:{
		lastCat(cat){
			if(cat == this.last){
				return false;
			} else{
				this.last = cat
				return true;
			}
		}
	},
	computed:{
		tableData() {
			let row = /(<tr.*>)(.|\n)*?(<\/tr>)/gm
			let dataTag = /(<t[hd] class="column-\d">)|(<\/t[hd]>)/gm
			let data = []
			let header = []
			let rows = this.content.match(row)
			for (let i in rows){
				let cols = rows[i].split(dataTag)
				cols.shift()
				let rowData = {}
				let j = 0
				for (let str of cols){
					if(str!=undefined && str!='' && str!="0" && str!="Sort" && !str.match(dataTag)){
						if(i == 0){
							header.push(str)
						} else{
							if (str == "tick") {
								rowData[header[j]] = true
							} else if (str == "notick") {
								rowData[header[j]] = false
							} else {
								rowData[header[j]] = str
							}
							j++
						}
					}
				}
				if (i == 0) {
					// console.log(header)
					header[1] = "Silver";
					header[2] = "Gold";
					header[3] = "Platinum";
				}
				data.push(rowData)
			}
			data.shift()
			return data
		},	
	}
}
</script>

<style lang="scss">
.alignment{
	padding:0;
	padding-bottom: 10px;
}

// .searchRow {
//   padding-top: 10px;
//   background: #ddd;
//   input{
//     border-color: #000 !important;
//   }
//   .searchIconContainer{
//     // background: $CTgreen !important;
//   }
// }

.memberOptionsTable{
	width: 100%;
	th,td{
		width: 25%;
		padding-left:10px;
		box-sizing: border-box;
		overflow: auto;
		text-align: center;
	}

	.silverTabHead {
		background-color: $CTSilver;
	}

	.goldTabHead {
		background-color: $CTgold;
	}

	.platinumTabHead {
		background-color: $CTPlatinum;
	}

	th{
		// background: #AF272F;
		
		color: #fff;
		h3{
			color: #fff;
		}
	}
	.col-1{
		// font-weight: bold;
	}
	.redTick {
		width: 40px;
	}
	td {
		vertical-align: inherit;
	}
}

.displayOption {
	&:not(:last-of-type)::after {
		content: " - ";
	}
}

.displayOptionText {
	cursor: pointer;
}

.displayOption.current .displayOptionText {
	text-decoration: underline;
}

.paginationRemoveBullet li::before{
	content:none !important;
}

@include media-breakpoint-down(md){
	th h3{
		font-size: 1.2em;
	}
	.showCountBoagt{
		padding: 10px 0;
	}
}
</style>
